import CardProject from '../../components/items/CardProject'

import rater from '../../img/projects/rater.png'
import react from '../../img/technology/react.png'
import html from '../../img/technology/html.png'
import css from '../../img/technology/css.png'
import javaScript from '../../img/technology/javascript.png'

export default function Project7() {
  return (
    <div>
      <CardProject
        name="Rater"
        img={rater}
        text="O projeto Rater é uma aplicação web desenvolvida com foco na experiência do usuário, utilizando a biblioteca React para construção de uma interface moderna e responsiva. A principal funcionalidade da aplicação é o consumo da API TMDB (The Movie Database), que fornece uma vasta gama de dados e informações sobre filmes, séries e elencos.
        
        Na Home, os usuários podem explorar os filmes mais populares do momento, com uma interface que facilita a navegação e a descoberta de novos conteúdos. Além disso, a aplicação possui uma barra de pesquisa poderosa, permitindo que os usuários busquem por qualquer filme ou série de seu interesse."
        app="https://rater-frontend-3stl.vercel.app/"
        repo="https://github.com/RiccettoDev/Rater-frontend"
        technology1={react}
        nameTechnology1="React JS"
        technology2={html}
        nameTechnology2="HTML"
        technology3={css}
        nameTechnology3="CSS"
        technology4={javaScript}
        nameTechnology4="JavaScript"
      />
    </div>
  )
}
